import endpoints, { baseApiUrl } from 'libs/src/config/endpoints';
import { HTTPStatusCode } from 'libs/src/enums';
import { fetchAsync } from 'libs/src/services/NetworkHelper';

export const fetchInvestmentStats = async (accountId: any): Promise<any> => {
  try {
    const request = {
      url:
        baseApiUrl +
        endpoints.investmentStats.replace('#{accountId}', accountId),
    };

    const response = await fetchAsync(request);
    if (response.status === HTTPStatusCode.OK) {
      return response.data;
    }
    return {};
  } catch (error) {
    return [];
  }
};
